import * as React from "react";
const MobilePreview = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={186}
    height={327}
    viewBox="0 0 186 327"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_138_2429)">
      <path d="M185 0H0V332H185V0Z" fill="white" />
      <path d="M185 0H0V38.8537H185V0Z" fill="#1578F7" />
      <path
        d="M172.296 28.5229H12.7031C10.5587 28.5229 8.82031 26.7839 8.82031 24.6385V14.0045C8.82031 11.8592 10.5587 10.1201 12.7031 10.1201H172.296C174.44 10.1201 176.179 11.8592 176.179 14.0045V24.6385C176.179 26.7839 174.44 28.5229 172.296 28.5229Z"
        fill="white"
      />
      <path
        d="M17.9999 15L19.3907 17.6335L22.5 18.0557L20.25 20.1056L20.7813 23L17.9999 21.6335L15.219 23L15.75 20.1056L13.5 18.0557L16.6095 17.6335L17.9999 15Z"
        stroke="#E3E6FA"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip1_138_2429)">
        <rect
          width={161}
          height={109}
          transform="translate(12 60)"
          fill="#F2F3F8"
        />
        <path
          opacity={0.2}
          d="M156.131 115.388C197.313 115.388 217.376 138.278 257.503 169C224.769 169 84.6273 169 44.1973 169C79.0444 143.699 114.947 115.388 156.131 115.388Z"
          fill="#D3DAFB"
        />
        <path
          opacity={0.2}
          d="M19.051 106.858C63.0695 106.858 91.5501 136.489 130.907 169C79.2676 169 -45.7849 169 -92.8047 169C-54.7887 136.489 -24.9676 106.858 19.051 106.858Z"
          fill="#CDD9FF"
        />
        <path
          opacity={0.5}
          d="M92.5 107C98.8518 107 104 102.075 104 96C104 89.9249 98.8518 85 92.5 85C86.1487 85 81 89.9249 81 96C81 102.075 86.1487 107 92.5 107Z"
          fill="#D3DAFB"
        />
      </g>
      <path
        d="M84.7941 188H14.2059C12.9876 188 12 189.007 12 190.25V194.75C12 195.993 12.9876 197 14.2059 197H84.7941C86.0124 197 87 195.993 87 194.75V190.25C87 189.007 86.0124 188 84.7941 188Z"
        fill="#E3E8FF"
      />
      <path
        opacity={0.5}
        d="M151.781 215H14.2188C12.9933 215 12 215.895 12 217C12 218.105 12.9933 219 14.2188 219H151.781C153.007 219 154 218.105 154 217C154 215.895 153.007 215 151.781 215Z"
        fill="#E3E8FF"
      />
      <path
        d="M49.7778 237H14.2222C12.9949 237 12 237.97 12 239.167V247.833C12 249.03 12.9949 250 14.2222 250H49.7778C51.0051 250 52 249.03 52 247.833V239.167C52 237.97 51.0051 237 49.7778 237Z"
        fill="#E3E8FF"
      />
      <path
        opacity={0.2}
        d="M172.5 270.75H13.5V277.25H172.5V270.75Z"
        fill="#CED1DE"
      />
      <path
        opacity={0.2}
        d="M172.5 286.25H13.5V292.75H172.5V286.25Z"
        fill="#CED1DE"
      />
      <path
        opacity={0.2}
        d="M172.5 301.75H13.5V308.25H172.5V301.75Z"
        fill="#CED1DE"
      />
    </g>
    <defs>
      <clipPath id="clip0_138_2429">
        <rect x={0.5} width={185} height={327} rx={8} fill="white" />
      </clipPath>
      <clipPath id="clip1_138_2429">
        <rect
          width={161}
          height={109}
          fill="white"
          transform="translate(12 60)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default MobilePreview;
